import { TabNames, ScreenNames } from "@/utilities/CommonUtilities";

export default {
    namespaced: true,
    state: {
        tabDatas: {},
        filterInfo: null,  
        currentTab: TabNames.All,
        selectedTab: TabNames.All,
        currentScreen:  ScreenNames.Calendar,
        selectedDate:null,
        currentLanguage: 'en',
    },
    getters: {
        getAppLanguage (state) {
            return state.currentLanguage;
        }, 
        getFilterInfo(state) {
            if(state.filterInfo != null) {
                let thisFilterInfo = {};
                Object.assign(thisFilterInfo, state.filterInfo);
                return thisFilterInfo;
            }
            return null;
        },
        getTabInfo(state) {
            // {userID:null, reasonID: null, typeID: null,dateType:FN, fromDate: null, toDate: null}
            return function(tabName) {
                let thisTabInfo = {};
                Object.assign(thisTabInfo, state.tabDatas[tabName]);
                return thisTabInfo;
            }
        },
        getVacationById(state) {
            return function(vacationID) {
                let allTabsInfo = Object.values(state.tabDatas);
                for (let tabIndex = 0; tabIndex < allTabsInfo.length; tabIndex++) {
                    let allPageItems = allTabsInfo[tabIndex].pageItems;
                    for (let index = 0; index < allPageItems.length; index++) {

                        const element = allPageItems[index];
                        if(element.id == vacationID) {
                            return element;
                        }
                    }
                }
            }
        }
    },
    mutations: {
        resetTabInfo(currentState, tabName) {
            let initialValues =  {
                currentPage: 1,
                totalPage: null,
                pageItems: []
            };
            currentState.tabDatas[tabName] = initialValues;
        },
        setTabInfo(currentState, payload) {
            currentState.tabDatas[payload.tabName] = payload.tabInfo;
        },
        // Để chọn My list, hoặc all staff
        setCurrentTab(currentState, tabName) {
            currentState.currentTab = tabName;
        },
        // switch giữa tab approved với tab inprogress
        setSelectedTab(currentState, tabName){
            currentState.selectedTab = tabName;
        },
        // set previous screen: đi từ màn hình nào sang
        setCurrentScreen(currentState, screenName) {
            currentState.currentScreen = screenName;
        },
        setSelectedDate(currentState, date) {
            currentState.selectedDate = date;
        },
        setSelectedLanguage(currentState, language) {
            currentState.currentLanguage = language;
        },
        signOut(currentState) {
            currentState.currentTab = TabNames.All;
            currentState.selectedTab = TabNames.All;
            currentState.currentScreen = ScreenNames.Calendar;
            currentState.selectedDate = null;
            currentState.filterInfo = null;
            currentState.tabDatas = {};
        },
        saveFilter(currentState, info) {
            currentState.filterInfo = info;
            //{userID:null, reasonID: null, typeID: null,dateType:FN, fromDate: null, toDate: null}
        }
    },
    actions: {
        resetAllTabInfo(context) {
            context.commit('resetTabInfo', TabNames.MyList);
            context.commit('resetTabInfo', TabNames.Requesting);
            context.commit('resetTabInfo', TabNames.All);
        }
    }
}